import { render, staticRenderFns } from "./AuthModal.vue?vue&type=template&id=a3221fbe&scoped=true&"
import script from "./AuthModal.vue?vue&type=script&lang=js&"
export * from "./AuthModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3221fbe",
  null
  
)

export default component.exports